const Qrcode = function ({ width, height, color }) {
  return (
    <svg
      width={width} // added size here
      height={height} // added size here
      fill={color} // added color here
      viewBox="0 0 105 105"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M54.6799 0.5H64.5842V5.45217H59.6321V10.4043H49.7237V25.2649H39.8193V20.3087H44.7715V5.45227H54.6799V0.5Z"
        fill="white"
      />
      <path
        d="M0.201172 0.5V35.1653H34.8665V0.5H0.201172ZM29.914 30.2128H5.15261V5.45144H29.914V30.2128Z"
        fill="white"
      />
      <path
        d="M69.5361 0.5V35.1653H104.201V0.5H69.5361ZM99.2489 30.2128H74.4876V5.45144H99.2489V30.2128Z"
        fill="white"
      />
      <path
        d="M10.1055 10.4043H24.9619V25.2607H10.1055V10.4043Z"
        fill="white"
      />
      <path
        d="M79.4365 10.4043H94.2929V25.2607H79.4365V10.4043Z"
        fill="white"
      />
      <path
        d="M54.6797 15.3564H59.6319V20.3086H54.6797V15.3564Z"
        fill="white"
      />
      <path
        d="M59.632 20.3089H64.5842V40.1177H59.632V30.2134H54.6799V35.1656H49.7236V25.2653H59.632V20.3089Z"
        fill="white"
      />
      <path
        d="M39.8184 30.2128H44.7706V35.165H49.7227V40.1171H44.7706V50.0215H49.7227V45.0693H54.679V40.1171H59.6311V54.9777H49.7227V59.9299H44.7706V54.9777H39.8184V45.0693H29.9141V40.1171H39.8184V30.2128Z"
        fill="white"
      />
      <path
        d="M10.1055 40.1178H20.0098V45.0699H10.1055V40.1178Z"
        fill="white"
      />
      <path
        d="M64.583 40.1178H74.4873V45.0699H69.5352V50.0221H64.583V40.1178Z"
        fill="white"
      />
      <path
        d="M79.4365 40.1178H84.3887V45.0699H79.4365V40.1178Z"
        fill="white"
      />
      <path
        d="M0.201172 45.0692H10.1055V50.0214H15.0577V54.9776H10.1055V59.9298H5.15334V50.0214H0.201172L0.201172 45.0692Z"
        fill="white"
      />
      <path
        d="M20.0098 45.0692H29.9141V50.0214H24.9619V54.9776H29.9141V59.9298H20.0098V45.0692Z"
        fill="white"
      />
      <path
        d="M84.3916 45.0692H89.3438V50.0214H94.296V64.8819H89.3438V59.9298H79.4354V64.8819H74.4873V54.9776H84.3916V45.0692Z"
        fill="white"
      />
      <path
        d="M29.9131 50.0217H34.8653V54.9739H29.9131V50.0217Z"
        fill="white"
      />
      <path d="M99.248 50.0217H104.2V54.9739H99.248V50.0217Z" fill="white" />
      <path
        d="M34.8662 54.9783H39.8184V64.8827H29.9141V59.9305H34.8662V54.9783Z"
        fill="white"
      />
      <path d="M59.6318 54.9783H64.584V59.9305H59.6318V54.9783Z" fill="white" />
      <path
        d="M0.201172 59.9308H5.15334V64.883H0.201172V59.9308Z"
        fill="white"
      />
      <path d="M10.1055 59.9308H15.0576V64.883H10.1055V59.9308Z" fill="white" />
      <path
        d="M49.7227 59.9308H59.6311V64.883H54.6789V74.7873H49.7227V84.6916H44.7705V74.7873H39.8184V64.883H44.7705V69.8351H49.7227V59.9308Z"
        fill="white"
      />
      <path d="M64.583 59.9308H69.5352V64.883H64.583V59.9308Z" fill="white" />
      <path d="M99.248 59.9308H104.2V64.883H99.248V59.9308Z" fill="white" />
      <path d="M59.6318 64.8822H64.584V74.7866H59.6318V64.8822Z" fill="white" />
      <path
        d="M84.3916 64.8822H89.3438V74.7866H84.3916V64.8822Z"
        fill="white"
      />
      <path d="M94.2969 64.8822H99.249V69.8344H94.2969V64.8822Z" fill="white" />
      <path
        d="M74.4885 69.8347H79.4367V74.7869H84.3929V84.6912H99.2493V89.6434H79.4362V99.5477H74.4881V89.6434H69.536V94.5956H64.5838V99.5477H69.536V104.5H44.7715V99.5477H59.632V89.6434H64.5842V74.787H74.4885V69.8347Z"
        fill="white"
      />
      <path
        d="M0.201172 69.8347V104.5H34.8665V69.8347H0.201172ZM29.914 99.5475H5.15261V74.7862H29.914V99.5475Z"
        fill="white"
      />
      <path
        d="M54.6797 74.7872H59.6319V79.7394H54.6797V74.7872Z"
        fill="white"
      />
      <path
        d="M89.3447 74.7872H99.2491V79.7394H89.3447V74.7872Z"
        fill="white"
      />
      <path
        d="M10.1055 79.7355H24.9619V94.5919H10.1055V79.7355Z"
        fill="white"
      />
      <path d="M99.248 79.7355H104.2V84.6877H99.248V79.7355Z" fill="white" />
      <path
        d="M39.8193 84.6911H44.7715V89.6433H49.7237V94.5955H39.8193V84.6911Z"
        fill="white"
      />
      <path d="M49.7227 84.6911H59.627V89.6433H49.7227V84.6911Z" fill="white" />
      <path
        d="M89.3447 94.5961H94.2969V99.5482H89.3447V94.5961Z"
        fill="white"
      />
      <path d="M99.248 94.5961H104.2V99.5482H99.248V94.5961Z" fill="white" />
      <path d="M79.4365 99.5475H84.3887V104.5H79.4365V99.5475Z" fill="white" />
    </svg>
  );
};

export default Qrcode;
